var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceDigitalDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 24,
    viewBox: "0 0 46 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.7188 14.0531C45.6007 12.8454 45.6007 11.1766 44.7188 9.96889L38.481 1.38335C37.8572 0.505031 36.8463 0 35.7923 0H3.35553C1.50568 0 0 1.53705 0 3.42543V20.5746C0 22.4629 1.50568 24 3.35553 24H35.7923C36.8463 24 37.8572 23.495 38.481 22.6166L44.7188 14.0531Z",
    fill: "#00FF20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceDigitalDocuments);
export default __webpack_public_path__ + "static/media/service_digital_documents.4b364e7e99fe60cf39c4e3268c2bf10b.svg";
export { ForwardRef as ReactComponent };